var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWosrepowork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13104 -1615)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-13104 1615)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13100 1620.132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.61-397.72H696q-4.445,0-8.891,0a2.376,2.376,0,0,1-2.573-2.554q0-7.863,0-15.726a2.4,2.4,0,0,1,2.538-2.562q11.907-.01,23.813,0a2.381,2.381,0,0,1,2.517,2.531q0,7.93,0,15.86a2.345,2.345,0,0,1-2.445,2.448c-2.993.008-5.987,0-8.98,0h-.615c.169.547.288,1.016.458,1.466.463,1.223.069.987,1.383,1.008.819.013,1.638-.01,2.457.007a1.184,1.184,0,0,1,1.238,1.565,1.049,1.049,0,0,1-.859.747,1.956,1.956,0,0,1-.4.023q-6.657,0-13.314,0c-.912,0-1.4-.483-1.321-1.288.064-.653.539-1.04,1.326-1.047,1.013-.01,2.026-.017,3.038.006a.494.494,0,0,0,.565-.416C696.134-396.312,696.362-396.966,696.61-397.72Zm2.326-6.329c3.6,0,7.208-.005,10.812.008.4,0,.54-.109.539-.529q-.023-5.16,0-10.321c0-.391-.114-.506-.508-.506q-10.79.016-21.58,0c-.445,0-.546.149-.544.565.014,3.4.008,6.791.008,10.187,0,.594,0,.6.595.6Z",
    transform: "translate(-684.535 418.567)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.267 5.712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743.464-356.52V-359.1a.609.609,0,0,1,.658-.661c.675,0,1.35,0,2.025,0,.1,0,.135.031.134.135,0,.465,0,.93,0,1.395,0,.357.142.5.5.506.473,0,.945,0,1.418,0,.086,0,.107.024.107.107,0,1.222,0,2.445,0,3.667a.6.6,0,0,1-.657.654h-3.555a.591.591,0,0,1-.629-.625Q743.462-355.22,743.464-356.52Z",
    transform: "translate(-743.464 359.759)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.71-358.849l1.526,1.519c-.024,0-.06.006-.1.007-.443,0-.885,0-1.328,0-.075,0-.107-.018-.106-.1,0-.473,0-.945,0-1.418C779.708-358.85,779.712-358.861,779.71-358.849Z",
    transform: "translate(-776.467 358.935)",
    fill: "currentColor",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 9.361,
    height: 1.207,
    rx: 0.603,
    transform: "translate(12.823 6.839)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.637,
    height: 1.207,
    rx: 0.603,
    transform: "translate(22.478 6.839)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.163,
    height: 1.207,
    rx: 0.603,
    transform: "translate(12.823 9.843)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.77,
    height: 1.207,
    rx: 0.603,
    transform: "translate(18.344 9.843)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWosrepowork);
export default __webpack_public_path__ + "static/media/wosrepowork.522f05d9.svg";
export { ForwardRef as ReactComponent };